<template>
    <div>
        <b-modal
            v-model="openModalShow"
             size="xxl"
             ok-variant="success"
             ok-title="Confirmă"
             cancel-variant="danger"
             cancel-title="Anulează"
             header-bg-variant="whiteModal"
             body-bg-variant="whiteModal"
             hide-footer
             hide-header
             centered
             id="whiteModal"
             @hide="$emit('hideTempModal')"
        >
            <div class="modal-body flex">
                <h3>Îți recomandăm ca la acest pas să utilizezi 2 monitoare. Reduce timpul de lucru cu până la 70%</h3>
                <div class="blue-button" @click="$emit('hideTempModal')">Ok. Am înteles.</div>
                <img src="@/assets/images/M3/M3Sketch/douamonitoare.png" class="doua-monitoare">
            </div>
        </b-modal>
    </div>
</template>

<script>
import {BModal, BForm, BFormGroup, BFormInput, BButton, BIconTrash, BFormTextarea, BFormFile, BIconUpload} from 'bootstrap-vue';
import vSelect from 'vue-select'
export default {
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BIconTrash,
        BFormTextarea,
        BFormFile,
        BIconUpload,
        vSelect
    },
    props: {
        mysmisPopup: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            searchQuery: '',
            form: {
                descriere: '',
            },
            file1: null,
            file2: null,
        };
    },
    computed: {
        openModalShow: {
            get(){
                return this.mysmisPopup
            },
            set(achizitiiModal){
                return achizitiiModal
            }
        }
    },
    methods: {
        pickFile1(doc){
            let input = this.$refs.fileUpload;

            input.click()
            this.file1 = doc;
        },
        pickFile2(doc){
            let input = this.$refs.fileUpload2;

            input.click()
            this.file2 = doc;
        },
        uploadFile(e){
            let file =  new FormData;
            file.append('file', e.target.files[0]);
            file.append('location' ,this.file1.value);
            file.append('_method','PUT');
        }
    },
};
</script>

<style>
.modal-xxl{
    max-width: 1500px;
    min-height: inherit;
    height: 100%;
}
#whiteModal{
    overflow: hidden;
}
#whiteModal .modal-content {
    display: flex;
}
#whiteModal .modal-body-content{
    width: 75%;
    padding: 20px;
}
#whiteModal___BV_modal_backdrop_ {
    background-color: transparent !important;
}
#whiteModal .modal-dialog {
    background: rgba(255, 255, 255, 0.66) !important;
    border: 3px solid #04e2c2 !important;
    backdrop-filter: blur(4px);
    position: relative;
    padding: 0px;
    max-height: 76vh;
    border-radius: 6px;
}
#whiteModal .modal-dialog .opacityNone {
    background-color: rgba(255, 255, 255, 0.61) !important;
    border: none !important;
    position: relative;
}
#whiteModal___BV_modal_header_{
    display: none;
}
#whiteModal .modal-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;

}
#whiteModal .modal-body{
    background: rgba(255, 255, 255, 0.6);
}
#whiteModal .modal-content {
    border: 2px solid #fff;
    background-color: rgba(255, 255, 255, 0.70) !important;
}
</style>
<style scoped>
.flex{
    display: flex;
    flex-direction: column;
}
h3{
    padding: 20px 0;
    text-align: center;
    font-size: 25px;
    font-weight: 700;
    color: #515679;
    margin: 0;
    line-height: 1;
}
.doua-monitoare{
    max-width: 960px;
    display: flex;
    align-self: center;
    justify-content: center;
    object-fit: cover;
}
.blue-button{
    background: #04e2c2;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    padding: 5px 20px;
    text-align: center;
    max-width: 250px;
    align-self: center;
    margin-top: -10px;
    cursor: pointer;
}
</style>